module.exports = __webpack_public_path__ + "fonts/SFUIText-BoldItalic.a8624435.woff";